import AuthenticationService from '../../services/AuthenticationService';

const authenticationService = new AuthenticationService();

export const actions = {
    async login({ commit, state }) {
        const appConfig = state.appConfig;
        await authenticationService.init(appConfig, state.context);
        commit('LOGIN', { account: authenticationService.accountObj, token: authenticationService.tokenResponse?.accessToken });
    },
    logout() {
        authenticationService.logout();
    },
    async refreshLoginToken({ commit }) {
        await authenticationService.refresh();
        commit('UPDATE_TOKEN', authenticationService.tokenResponse.accessToken);
        return authenticationService.tokenResponse.accessToken;
    },
    async getUserAuthentication({ commit, dispatch }) {
        try {
            const userInfo = await dispatch('useApiData', { name: 'GetUserAuthentication' });

            const globalUserData = {
                userID: userInfo.data.id,
                organizationId: userInfo.data.organizationId,
                licenses: {
                    has_mobile_license: userInfo.data.licenses?.includes('Mobile'),
                    has_web_license: userInfo.data.licenses?.includes('Web'),
                    has_portal_license: userInfo.data.licenses?.includes('Portal')
                },
                isAdmin: userInfo.data.isAdmin === 1,
                isFeedbackEditor: userInfo.data.isFeedbackEditor === 1,
                isSuper: userInfo.data.isSuper === 1,
                userName: userInfo.data.userName,
                sessionId: '',
                organizationLanguage: userInfo.data.organizationLanguage,
                organizationName: userInfo.data.organizationName,
                locale: userInfo.data.organizationLanguage == 'NL' ? 'nl-NL' : 'en-US',
                isAuthorized: userInfo.data.organizationId > 0,
                isAuthenticated: userInfo.data.id > 0,
                hasNedGlobeServices: userInfo.data.hasNedGlobeServices
            };
            // update userInfo object in store
            commit('SET_USERINFO', globalUserData);
            return {
                isAuthorized: globalUserData.isAuthorized,
                isAdmin: globalUserData.isAdmin,
                isFeedbackEditor: globalUserData.isFeedbackEditor,
                isSuper: globalUserData.isSuper,
                has_mobile_license: globalUserData.licenses.has_mobile_license,
                has_web_license: globalUserData.licenses.has_web_license,
                has_portal_license: globalUserData.licenses.has_portal_license,
            };

        } catch (error) {
            if (error.response && error.response.data && error.response.data.message) {
                // get username from: "{userName}: not authorized<br><br>NedGlobe foutnummer:{foutnummer}"
                const tokens = error.response.data.message.split(':');
                if (tokens && tokens.length > 0) {
                    // the username is in the third token
                    commit('SET_UNKNOWNUSERNAME', tokens[2]);
                } else {
                    // no NedGlobe errornumber found, use whole message
                    commit('SET_UNKNOWNUSERNAME', 'Onbekende gebruiker');
                }
            }
            throw new Error(error);
        }
    }
};

export default actions;
